import axios from "axios";

// Same-origin relative URL — works on any domain (rwanabizinlega.mu,
// www.rwanabizinlega.mu, bizin-lega.emergent.host, preview.emergentagent.com).
// The Kubernetes ingress routes /api/* to the FastAPI backend on every host
// it serves, so we no longer rely on a baked-in absolute URL.
export const API = "/api";

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function formatApiError(detail) {
  if (detail == null) return "Une erreur est survenue.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
